import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AreaOfScrap, ScrapReason } from '../types/scrap-reason';
import { HttpClient } from '@angular/common/http';
import { ConstantsProviders } from '../../../core/providers/constants/constants';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';
import { DepartmentName } from '../../../core/types/department';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteScrapService extends IApiBackendRouteService {
  constructor(
    protected readonly http: HttpClient,
    protected readonly constants: ConstantsProviders
  ) {
    super();
  }

  urlRoute = `${API_ENDPOINTS.SCRAP_REASONS}`;

  getScrapReasons(type?: string, search?: string): Observable<ScrapReason[]> {
    const params: { [key: string]: string } = {};

    if (type) {
      params.type = type;
    }
    if (search) {
      params.search = search;
    }
    return this.http.get<ScrapReason[]>(`${this.urlRoute}`, { params });
  }

  getByDepartment(department: DepartmentName): Observable<ScrapReason[]> {
    return this.http.get<ScrapReason[]>(
      `${this.urlRoute}/department/${department}`
    );
  }
  getAreaByDepartment(department: DepartmentName): Observable<AreaOfScrap[]> {
    return this.http.get<AreaOfScrap[]>(`${this.urlRoute}/area/${department}`);
  }

  getScrapReasonsByDepartment(
    department: DepartmentName
  ): Observable<ScrapReason[]> {
    return this.http.get<ScrapReason[]>(
      `${this.urlRoute}/department/${department}`
    );
  }
}
